import PropTypes from 'prop-types';
// @mui
import Table from '@mui/material/Table';
import Divider from '@mui/material/Divider';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import CardHeader from '@mui/material/CardHeader';
import Card from '@mui/material/Card';
import TableContainer from '@mui/material/TableContainer';
import CardContent from "@mui/material/CardContent";
// utils
import { fCurrencyEuroWith00 } from '../../utils/format-number';
// components
import Label from '../../components/label';
import { TableHeadCustom } from '../../components/table';

// ----------------------------------------------------------------------

export default function FinancialResumeTable({ title, subheader, tableData, tableLabels, ...other }) {
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader}/>

      <CardContent>

        <TableContainer style={{ maxHeight: 400, minHeight: 400 }}>

            <Table sx={{ minWidth: 600 }} stickyHeader>
              <TableHeadCustom headLabel={tableLabels} />
              <TableBody>
                {tableData.map((row) => (
                  <FinancialResumeTableRow key={row.id} row={row} />
                ))}
              </TableBody>
            </Table>

        </TableContainer>

      </CardContent>


      <Divider sx={{ borderStyle: 'dashed' }} />

    </Card>
  );
}

FinancialResumeTable.propTypes = {
  subheader: PropTypes.string,
  tableData: PropTypes.array,
  tableLabels: PropTypes.array,
  title: PropTypes.string,
};

// ----------------------------------------------------------------------

function FinancialResumeTableRow({ row }) {

  return (
      <TableRow>
        <TableCell>{row.date}</TableCell>

        <TableCell>{fCurrencyEuroWith00(row.startBalance || '0')}</TableCell>

        <TableCell>
            {fCurrencyEuroWith00(row.abono || '0')}
        </TableCell>

        <TableCell>
            {fCurrencyEuroWith00(row.gasto || '0')}
        </TableCell>

        <TableCell>
          <Label
            variant="soft"
            color={row.ahorro <= 0 ? 'error' : 'success'}
          >
            {fCurrencyEuroWith00(row.ahorro || '0')}
          </Label>
        </TableCell>

        <TableCell>{fCurrencyEuroWith00(row.endBalance || '0')}</TableCell>

      </TableRow>
  );
}

FinancialResumeTableRow.propTypes = {
    row: PropTypes.object,
};
